import { SlidersHorizontal, BookmarkPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export function SearchFilters({ f }) {
  const {
    show, cats, counties, subList, isProperty, user,
    category, setCategory, subcategory, setSubcategory, county, setCounty,
    area, setArea, condition, setCondition, minPrice, setMinPrice,
    maxPrice, setMaxPrice, minBedrooms, setMinBedrooms, clearAll, saveSearch,
  } = f;
  return (
    <aside className={`${show ? "block" : "hidden"} lg:block lg:col-span-1 bg-white border border-slate-200 rounded-lg p-5 h-fit space-y-5`} data-testid="filters-sidebar">
      <div className="hidden lg:flex items-center gap-2 font-heading font-semibold text-slate-900"><SlidersHorizontal size={16} /> Filters</div>
      <div>
        <Label className="text-xs uppercase tracking-wide text-slate-500">Category</Label>
        <Select value={category} onValueChange={(v) => { setCategory(v); setSubcategory("all"); }}>
          <SelectTrigger data-testid="filter-category" className="mt-1"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All categories</SelectItem>
            {Object.keys(cats).map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {subList.length > 0 && (
        <div>
          <Label className="text-xs uppercase tracking-wide text-slate-500">Sub-category</Label>
          <Select value={subcategory} onValueChange={setSubcategory}>
            <SelectTrigger data-testid="filter-subcategory" className="mt-1"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              {subList.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
      {isProperty && (
        <div>
          <Label className="text-xs uppercase tracking-wide text-slate-500">Min. bedrooms</Label>
          <Select value={minBedrooms || "any"} onValueChange={(v) => setMinBedrooms(v === "any" ? "" : v)}>
            <SelectTrigger data-testid="filter-bedrooms" className="mt-1"><SelectValue placeholder="Any" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="any">Any</SelectItem>
              {[1, 2, 3, 4, 5].map((n) => <SelectItem key={n} value={String(n)}>{n}+</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
      <div>
        <Label className="text-xs uppercase tracking-wide text-slate-500">County</Label>
        <Select value={county} onValueChange={setCounty}>
          <SelectTrigger data-testid="filter-county" className="mt-1"><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-64">
            <SelectItem value="all">All Ireland</SelectItem>
            {counties.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide text-slate-500">Area / Town</Label>
        <Input data-testid="filter-area" className="mt-1" value={area} onChange={(e) => setArea(e.target.value)} placeholder="e.g. Swords, Douglas" />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide text-slate-500">Condition</Label>
        <Select value={condition} onValueChange={setCondition}>
          <SelectTrigger data-testid="filter-condition" className="mt-1"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Any</SelectItem>
            <SelectItem value="New">New</SelectItem>
            <SelectItem value="Used">Used</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide text-slate-500">Price range (€)</Label>
        <div className="flex gap-2 mt-1">
          <Input data-testid="filter-min-price" type="number" placeholder="Min" value={minPrice} onChange={(e) => setMinPrice(e.target.value)} />
          <Input data-testid="filter-max-price" type="number" placeholder="Max" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} />
        </div>
      </div>
      <Button variant="outline" data-testid="clear-filters" className="w-full" onClick={clearAll}>Clear all</Button>
      {user && (
        <Button variant="outline" data-testid="save-search" className="w-full gap-1.5 text-emerald-700 border-emerald-200" onClick={saveSearch}>
          <BookmarkPlus size={15} /> Save this search
        </Button>
      )}
    </aside>
  );
}
